import { getDomPromise, getNullPromise } from '../interruptiblePromises'
import {
  evaluateXpath,
  getCaseInsensitiveXPathTextSelector,
} from '../interruptibleXpath'

export const contactsDashboardSettingsUrl =
  'https://x.com/settings/contacts_dashboard'
export const contactsSettingsUrl = 'https://x.com/settings/contacts'
export const homeUrl = 'https://x.com'
export const authHomeUrl = 'https://x.com/home'
export const languageSettingsUrl = 'https://x.com/settings/language'
export const locationInformationUrl = 'https://x.com/settings/location'
export const mutedNotificationsSettingsUrl =
  'https://x.com/settings/notifications/advanced_filters'
export const profileSettingsUrl = 'https://x.com/settings/profile'
export const securitySettingsUrl = 'https://x.com/settings/security'
export const twoFaSettingsUrl =
  'https://x.com/settings/account/login_verification'
export const aiSettingsUrl = 'https://x.com/settings/grok_settings'
export const messagesUrl = 'https://x.com/messages'

export function getProfileUrl(): Promise<string> {
  const getAnchor = (node) =>
    evaluateXpath<HTMLAnchorElement>(
      node,
      `descendant::a[${getCaseInsensitiveXPathTextSelector(
        'aria-label',
        'profile',
      )}]`,
    )[0]

  const anchor = getAnchor(document)

  if (anchor) {
    return getNullPromise().then(() => anchor.href)
  }

  return getDomPromise(document, (node) => getAnchor(node) !== undefined)
    .then((node) => getAnchor(node))
    .then((anchorElement) => (anchorElement ? anchorElement.href : null))
}
